import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Button.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-bootstrap/esm/Modal.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/common/DropHint.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/diamonddetails/BackLinkSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/diamonddetails/ContactUsForDiamond.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/diamonddetails/DiamondDetailSummry.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/diamonddetails/Options.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/src/components/diamonddetails/ProductImages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/src/components/home/GoogleReviewBanner.tsx");
